const IQD_AMOUNT_FORMAT: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

/** Numeric IQD figure with grouping; preserves decimals (no rounding to whole IQD). */
export function formatIqdMoney(amount: number | undefined | null): string {
  const n = Number(amount ?? 0);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString("en-US", IQD_AMOUNT_FORMAT);
}

/** IQD with unit trailing, numerals always LTR — used in cart, checkout, and payment modals. */
export function formatCheckoutIqd(amount: number | undefined | null): string {
  return `${formatIqdMoney(amount)}\u00A0IQD`;
}
